import styled from 'styled-components';
import { variant } from 'styled-system';
import { textStyles } from '../../../../theme/config/typography';
import { StyledInputProps } from '../Input/types';

export const StyledTextarea = styled.textarea.attrs({
  variant: 'body',
})<StyledInputProps>`
  width: 100%;
  height: 11.25rem;
  padding: 0.5rem 0.875rem;
  background-color: var(--surface);
  color: var(--ink);
  border-width: 1px;
  border-style: solid;
  border-color: ${({ isError }) => (isError ? 'var(--danger)' : 'var(--line)')};
  border-radius: var(--r-sm);
  ${variant({ variants: { ...textStyles } })}
  resize: none;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease;
  font-size: 0.875rem;
  &:focus {
    border-color: var(--brand-green);
    box-shadow: 0 0 0 3px rgba(118, 177, 89, 0.15);
  }
  &:disabled,
  &[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }
`;
